import { signal, effect } from "@angular/core";

import { createProxy } from "./create-proxy.function";
import { KeyInput } from "../types/key-input.type";
import { SignalTree } from "../types/signal-tree.type";
import { storageRoot } from "./storage-root.function";

export function storageSignalTree<T>(
    keyInput: KeyInput,
    fallback: T,
    options?: {
        type?: 'local' | 'session',
        debounce?: number,
        ttl?: number
    }
): SignalTree<T> {
    const { type = 'local', debounce = 300, ttl } = options ?? {};
    const rootValue$$ = signal<T>(structuredClone(fallback));
    let currentKey = '';
    let write: ((v: T) => void) | null = null;

    const getKey = () => typeof keyInput === 'function' ? keyInput() : keyInput;

    const initialKey = getKey();
    if (initialKey) {
        currentKey = initialKey;
        const { rootValue$$: storage$$, write: storageWrite } = storageRoot(initialKey, fallback, type, debounce, ttl);
        rootValue$$.set(storage$$());
        write = storageWrite;
    }

    effect(() => {
        const key = getKey();
        if (!key) return;

        if (key !== currentKey) {
            currentKey = key;

            const { rootValue$$: storage$$, write: storageWrite } = storageRoot(key, fallback, type, debounce, ttl);

            rootValue$$.set(storage$$());
            write = storageWrite;
        }

        const value = rootValue$$(); // 🔥 trigger

        write?.(value);
    });

    return createProxy(rootValue$$);
}